/**
 * Main About Block — view.js
 * Handles: Vision / Mission tab switching on the frontend.
 */

document.addEventListener( 'DOMContentLoaded', function () {
	// A page may contain multiple instances of this block
	document.querySelectorAll( '#about' ).forEach( initAboutBlock );
} );

function initAboutBlock( block ) {
	const tabBtns = block.querySelectorAll( '.emp-tab-btn' );
	const panels  = block.querySelectorAll( '.emp-panel' );

	if ( ! tabBtns.length || ! panels.length ) return;

	// ── Set initial visual state (vision = active by default) ────────
	setActiveTab( block, 'vision', tabBtns, panels );

	// ── Bind clicks ──────────────────────────────────────────────────
	tabBtns.forEach( function ( btn ) {
		btn.addEventListener( 'click', function () {
			const tab = this.dataset.tab;
			if ( ! tab ) return;
			setActiveTab( block, tab, tabBtns, panels );
		} );
	} );
}

function setActiveTab( block, tab, tabBtns, panels ) {
	// Update buttons
	tabBtns.forEach( function ( btn ) {
		const isActive = btn.dataset.tab === tab;
		btn.setAttribute( 'aria-pressed', isActive ? 'true' : 'false' );
		// Active = orange, Inactive = grey
		btn.style.backgroundColor = isActive ? '#f39c12' : '#e5e7eb';
		btn.style.color            = isActive ? '#ffffff' : '#374151';
		btn.style.boxShadow        = isActive ? '0 4px 12px rgba(243,156,18,0.35)' : '0 1px 4px rgba(0,0,0,0.1)';
	} );

	// Show / hide arrow images below active tab button
	block.querySelectorAll( '.emp-tab-arrow' ).forEach( function ( arrow ) {
		const isActive = arrow.classList.contains( 'emp-tab-arrow--' + tab );
		if ( isActive ) {
			arrow.classList.remove( 'hidden' );
			arrow.style.display = 'block';
		} else {
			arrow.classList.add( 'hidden' );
			arrow.style.display = 'none';
		}
	} );

	// Show / hide panels
	panels.forEach( function ( panel ) {
		const isActive = panel.dataset.panel === tab;
		if ( isActive ) {
			panel.classList.remove( 'hidden' );
			// Subtle fade-in
			panel.style.opacity   = '0';
			panel.style.transform = 'translateY(6px)';
			// Force reflow then animate
			void panel.offsetHeight;
			panel.style.transition = 'opacity 0.25s ease, transform 0.25s ease';
			panel.style.opacity    = '1';
			panel.style.transform  = 'translateY(0)';
		} else {
			panel.classList.add( 'hidden' );
			panel.style.transition = '';
		}
	} );
}
